export default "/images/vendor/flag-icon-css/flags/1x1/bj.svg?fb3d1c01b8a808e6fe1335322cb758a6";